/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMBookingIdRemarkRuleFormValidationData
 */
export interface BCMBookingIdRemarkRuleFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMBookingIdRemarkRuleFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMBookingIdRemarkRuleFormValidationData
     */
    bookingIdRemark?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BCMBookingIdRemarkRuleFormValidationData
     */
    brandAndMarket?: ValidationMessage;
}

export function BCMBookingIdRemarkRuleFormValidationDataFromJSON(json: any): BCMBookingIdRemarkRuleFormValidationData {
    return BCMBookingIdRemarkRuleFormValidationDataFromJSONTyped(json, false);
}

export function BCMBookingIdRemarkRuleFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMBookingIdRemarkRuleFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'bookingIdRemark': !exists(json, 'bookingIdRemark') ? undefined : ValidationMessageFromJSON(json['bookingIdRemark']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
    };
}

export function BCMBookingIdRemarkRuleFormValidationDataToJSON(value?: BCMBookingIdRemarkRuleFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'bookingIdRemark': ValidationMessageToJSON(value.bookingIdRemark),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
    };
}


